var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"app-version"},[_vm._v("\n    "+_vm._s(_vm.version)+"\n    "),(!_vm.isProd)?[_vm._v("\n        on "),_c('span',{class:_vm.styling},[_vm._v(_vm._s(_vm.env))])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }